import { actionType } from "../actionTypes";

export const contractorStats = (data)=>{
   return{
    type: actionType.CONTRACTOR_STATS,
    payload: data
   }
}

